import React, { useEffect } from 'react';
import { EditorView } from 'codemirror';
import { useCodeEditor } from './useCodeEditor';
import { githubLight, githubDark, snippetDark } from './Themes';
import { ICodeEditorProps } from './types';

interface ICodeEditorInstance extends Omit<ICodeEditorProps, 'extensions'> {}

export const CodeEditor = ({
	id,
	value,
	editable,
	theme,
	onChange,
	lang,
	refCallback
}: ICodeEditorInstance) => {
	const isEditable = EditorView.editable.of(editable);
	const testId = EditorView.contentAttributes.of({
		'data-testid': `cm-editor`,
		'data-cm-theme': theme,
		id
	});

	let editorTheme;
	switch (theme) {
		case 'dark':
			editorTheme = githubDark;
			break;
		case 'light':
			editorTheme = githubLight;
			break;
		case 'snippetDark':
			editorTheme = snippetDark;
			break;
		default:
			editorTheme = githubDark;
	}

	const extensions = [editorTheme, isEditable, testId];
	const { ref: editorRef, view } = useCodeEditor({
		id,
		value,
		extensions,
		editable,
		theme,
		onChange,
		lang
	});

	useEffect(() => {
		if (refCallback && view) {
			refCallback(view);
		}
	}, [view, refCallback]);

	return (
		<section
			aria-label={intl.tr('code.editor')}
			ref={editorRef as React.RefObject<HTMLElement>}
		/>
	);
};

export default CodeEditor;
